import {
  Dialog,
  Divider,
  Typography,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { FC } from "react";
import CDialogTitle from "components/CDialogTitle";
import CDialogTransition from "components/CDialogTransition";
import color from "context/MaterialUITheme/color";

type DialogProps = {
  open: boolean;
  handleClose: () => void;
};

const CLicensesDialog: FC<DialogProps> = ({ open, handleClose }) => {
  return (
    <Dialog
      open={open}
      maxWidth="lg"
      scroll={"paper"}
      fullWidth={true}
      onClose={handleClose}
      TransitionComponent={CDialogTransition}
      aria-labelledby="customized-dialog-title"
      onClick={(e) => {
        e.stopPropagation();
      }}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: 10,
        },
      }}
    >
      <DialogContent>
        <CDialogTitle onClose={handleClose}>
          Licenses and Disclosures
        </CDialogTitle>
        <Divider sx={{ marginBottom: 4 }} />
        <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
          <Typography color={color.black} textAlign={"justify"}>
            <Typography
              variant="h4"
              display={"flex"}
              color={color.black}
              fontWeight={"bold"}
              justifyContent={"center"}
            >
              NFTYDoor LLC Licenses and Disclosures
            </Typography>
            <br />
            <Typography variant="subtitle2" sx={{ color: color.gray }}>
              Effective date: 8/1/2022
            </Typography>
            <br /> NFTYDoor LLC (NMLS #: 2324343) is a mortgage lender whose
            main office is located at 1660 International Drive Suite 600 McLean,
            VA 22102 / Phone: (844) 975-5150 / Email:{" "}
            <span style={{ color: color.primary }}>Support@nftydoor.com</span>
            <br />
            <br />
            <Typography variant="h5" color={color.black}>
              NFTYDoor LLC holds the following state licenses:
            </Typography>
            <br />• District of Columbia - District of Columbia Mortgage Lender
            License (MLB2324343) issued by District of Columbia Department of
            Insurance and Banking
            <br />• Florida - Mortgage Lender License (MLD2275) issued by the
            Florida Office of Financial Regulation
            <br />• Illinois - Illinois Residential Mortgage License
            (MB.6761732) issued by the Illinois Department of Financial &
            Professional Regulation
            <br />• Maryland - Maryland Mortgage Lender License (2324343) issued
            by the Office of the Commissioner of Financial Regulation
            <br />• Virginia – Virginia Mortgage Lender License (MC-7475) issued
            by the Bureau of Financial Institutions
            <br /> <br />
            <Typography variant="h5" color={color.black}>
              Availability:
            </Typography>
            Residential mortgage loans offered by NFTYDoor LLC are not available
            in all states.
            <br /> <br />
            <Typography variant="h5" color={color.black}>
              General disclosures:
            </Typography>
            NFTYDoor LLC is an Equal Housing Lender. In accordance with federal
            law, we do not engage in business practices that discriminate on the
            basis of race, color, religion, national origin, sex, marital
            status, age (provided you have the capacity to enter into a binding
            contract), because all or part of your income may be derived from
            any public assistance program, or because you have, in good faith,
            exercised any right under the Consumer Credit Protection Act. The
            federal agency that administers our compliance with these federal
            laws is the Federal Trade Commission, Equal Credit Opportunity,
            Washington, DC, 20580.
          </Typography>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CLicensesDialog;
